import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

import { Section } from 'components/Section';
import { KpiDataVersionData } from 'generated/graphql';
import { useDataEntry } from 'pages/KPIs/hooks/useDataEntry';
import { useLibrary } from 'pages/KPIs/hooks/useLibrary';
import { DataEntryTableGroup } from 'pages/KPIs/DataEntryPage/components/DataEntryTableGroup/DataEntryTableGroup';

export const CompanyKPIs = (props: { companyId: string }) => {
  const library = useLibrary();
  const { models, operations } = useDataEntry(true);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [scrolledOnce, setScrolledOnce] = useState({});

  const noTemplate = models.company?.templateId == null;

  const settingsChanges = (models.company?.dataCollectionFrequency || [])
    .map((e) => {
      return {
        date: moment(e?.updated),
        user: e?.updatedBy,
        action: 'Settings updated',
      };
    })
    .concat(
      (models.company?.dataCollectionStartDate || []).map((e) => {
        return {
          date: moment(e?.updated),
          user: e?.updatedBy,
          action: 'Settings updated',
        };
      }),
    );

  let activities = settingsChanges
    .concat(
      models.audits
        .filter((e: any) => ['Saved', 'Published'].includes(e.action))
        .map((e: any) => {
          return {
            date: moment(e.changed),
            user: e.changedBy,
            action: {
              Saved: 'Draft saved',
              Published: 'Published',
            }[e.action as 'Saved' | 'Published'],
          };
        }),
    )
    .sort((a, b) => b.date.valueOf() - a.date.valueOf());

  activities = activities.filter(
    (e, i) =>
      !(
        i < activities.length - 1 &&
        e.action === 'Draft saved' &&
        activities[i + 1].action === 'Settings updated'
      ),
  );

  useEffect(() => {
    library.operations.loadKPIs().then();
  }, []);

  useEffect(() => {
    (async () => {
      await operations.loadCompanyByExtId(props.companyId);
    })();
  }, [props.companyId]);

  useEffect(() => {
    if (models.rows) {
      setRows(models.rows);
    }
  }, [models.rows]);

  useEffect(() => {
    if (models.columns) {
      setColumns(
        models.columns.slice(-6).map((c: any) => {
          return {
            field: c,
            headerName: c,
          };
        }),
      );
    }
  }, [models.columns]);

  function onGridRowEdit(
    groupName: string,
    gridRows: any,
    { column, indexes }: { column: any; indexes: any },
  ) {
    const [rowIndex] = indexes;

    const updatedRow = gridRows[rowIndex];
    const updatedValue = updatedRow[column.key];

    const changedDataItem = {
      indicatorId: updatedRow.id,
      name: updatedRow.name,
      type: updatedRow.type,
      period: column.key,
      value: updatedValue,
    } as KpiDataVersionData;

    operations.saveLocalChanges(groupName, changedDataItem);

    setRows({
      ...rows,
      [groupName]: gridRows,
    });
  }

  return (
    (!noTemplate &&
      models.dataVersion && (
        <Section>
          <div className="w-100 mx-auto px-3" style={{ maxWidth: 1200 }}>
            <Typography variant="h2" className="mb-3 mt-2 font-weight-bold">
              KPIs
            </Typography>
            {models.kpiGroups
              ?.sort((a: any, b: any) => (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase()))
              .map((kpiGroup: any, index: number) => (
                <DataEntryTableGroup
                  key={kpiGroup.name}
                  groupRows={rows[kpiGroup.name]}
                  columns={columns}
                  editable={false}
                  kpiGroup={kpiGroup}
                  isLoading={models.isLoading}
                  onGridRowEdit={onGridRowEdit}
                  // @ts-ignore
                  scrolledOnceGrid={scrolledOnce[kpiGroup.name]}
                  onScrolledOnce={() =>
                    setScrolledOnce({ ...scrolledOnce, [kpiGroup.name]: true })
                  }
                  showLastPeriod={false}
                />
              ))
            }
          </div>
        </Section>
      )
    ) ||
    ''
  );
};
